/*###########################################################################
// Section Navigator
//#########################################################################*/

import { gsap } from "gsap"
import { ScrollTrigger } from "gsap/ScrollTrigger"
gsap.registerPlugin(ScrollTrigger)
import { throttle } from "../utilities/_throttleDebounce"
import { scrollTo } from "../utilities/_scrollTo"

export default function sectionNavigator() {
	return {
		buttons: null,
		header: null,
		uid: null,
		fixed: false,
		ghost: null,
		ghostOffset: 0,
		scrollTriggerInstances: [],

		init() {
			const self = this

			this.buttons = this.$el.querySelectorAll('button[data-section-uid]')
			this.uid = this.buttons[0].getAttribute('data-section-uid')
			this.mainEl = this.$el
			this.ghost = document.querySelector('.sectionNavigator__ghost')

			if (this.ghost !== null) {
				this.$watch('fixed', () => {
					if (this.fixed) {
						this.ghost.style.height = this.$el.getBoundingClientRect().height + 'px'
					} else {
						this.ghost.style.height = 0 + 'px'
					}
				})
			}

			self.handleSticky()
			self.handleSections()
		},

		handleSticky() {
			const self = this

			self.header = document.querySelector('.header')

			window.addEventListener('scroll', function() {
				const rect = self.$el.parentNode.getBoundingClientRect()
				self.fixed = rect.top <= 0

				if (self.header.classList.contains('header--scrolling-up') && self.fixed) {
					self.$el.style.top = self.header.getBoundingClientRect().height + self.header.getBoundingClientRect().top + 'px'
				} else if (self.fixed) {
					self.$el.style.top = self.header.getBoundingClientRect().height + self.header.getBoundingClientRect().top + 'px'
				} else {
					self.$el.style.top = ''
				}
			})
		},

		handleSections() {
			const self = this

			for (let i = 0; i < this.buttons.length; i++) {
				const button = this.buttons[i]
				const section = document.getElementById(button.getAttribute('data-section-uid'))

				self.scrollTriggerInstances[i] = ScrollTrigger.create({
					trigger: section,
					start: "top center",
					end: "bottom center",
					scrub: true,
					onEnter: () => {
						self.uid = button.getAttribute('data-section-uid')
					},
					onEnterBack: () => {
						self.uid = button.getAttribute('data-section-uid')
					},
				})
			}
		},

		handleSelectChange($event) {
			const self = this

			const select = $event.target

			if (select !== null) {
				self.scrollToSection(select.options[select.selectedIndex].value)
			}
		},

		scrollToSection(uid) {
			const self = this

			self.uid = uid
			const sectionElement = document.getElementById(uid)

			self.scrollTriggerInstances.forEach(instance => {
				instance.disable()
			})

			if (sectionElement !== null) {
				const topMargin = parseInt(window.getComputedStyle(sectionElement).marginTop)
				const offsetAmount = this.mainEl.getBoundingClientRect().height + topMargin

				scrollTo(sectionElement, -offsetAmount)

				setTimeout(() => {
					self.scrollTriggerInstances.forEach(instance => {
						instance.enable()
					})
				}, 1000)
			}
		}
	}
}
